var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebBasedAccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 39.161 33.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud_setting",
    transform: "translate(-0.6 -2.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24938",
    "data-name": "Path 24938",
    d: "M37.493,16.3a7.729,7.729,0,0,0-3.374-2.323c.013-.2.02-.388.02-.571A9.9,9.9,0,0,0,15.76,8.284a6.319,6.319,0,0,0-9.538,5.445c0,.085,0,.172.006.256a7.663,7.663,0,0,0,2.53,14.893,1.152,1.152,0,1,0,0-2.3A5.357,5.357,0,0,1,7.724,15.959a1.152,1.152,0,0,0,.9-1.371,4.123,4.123,0,0,1-.1-.861,4.01,4.01,0,0,1,6.823-2.868,1.137,1.137,0,0,0,1.039.309,1.15,1.15,0,0,0,.835-.688,7.6,7.6,0,0,1,14.61,2.926,7.679,7.679,0,0,1-.111,1.234,1.151,1.151,0,0,0,.916,1.318A5.357,5.357,0,0,1,31.6,26.57a1.152,1.152,0,1,0,0,2.3A7.674,7.674,0,0,0,37.493,16.3Z",
    transform: "translate(0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24939",
    "data-name": "Path 24939",
    d: "M24.356,22.969H23.6a5.993,5.993,0,0,0-.909-2.2l.533-.533a1.152,1.152,0,1,0-1.63-1.628l-.531.531a5.956,5.956,0,0,0-2.2-.909v-.756a1.152,1.152,0,1,0-2.3,0v.756a5.965,5.965,0,0,0-2.2.909l-.531-.531a1.152,1.152,0,0,0-1.63,1.628l.533.533a5.971,5.971,0,0,0-.909,2.2h-.754a1.152,1.152,0,0,0,0,2.3h.754a5.987,5.987,0,0,0,.909,2.2l-.533.533a1.152,1.152,0,1,0,1.631,1.628l.531-.531a5.956,5.956,0,0,0,2.2.909v.756a1.153,1.153,0,0,0,2.305,0v-.756a5.965,5.965,0,0,0,2.2-.909l.531.531a1.152,1.152,0,1,0,1.631-1.628l-.533-.533a5.956,5.956,0,0,0,.909-2.2h.754a1.153,1.153,0,1,0,0-2.3Zm-6.647,4.856a3.7,3.7,0,1,1,3.7-3.7A3.708,3.708,0,0,1,17.708,27.825Z",
    transform: "translate(2.472 3.598)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebBasedAccess);
export default __webpack_public_path__ + "static/media/WebBasedAccess.e9c43b8b3787d3592729ea2a7a22cb3b.svg";
export { ForwardRef as ReactComponent };